<template>
  <section class="section" id="reward-program-panel">
    <b-loading
      :is-full-page="true"
      :active="isLoadingHistory"
      :can-cancel="false"
    ></b-loading>

    <div class="container">
      <div class="reward-program-header">
        <h1 class="title is-3">{{ $t("rewardProgram.pageTitle") }}</h1>
        <p class="subtitle is-6">
          {{ $t("rewardProgram.pageSubtitle") }}
        </p>
      </div>

      <b-tabs
        v-model="activeTab"
        position="is-centered"
        class="block"
        size="is-large"
        expanded
        @input="handleTabChange"
      >
        <b-tab-item :label="$t('rewardProgram.rulesTab')">
          <reward-program-rules />
        </b-tab-item>

        <b-tab-item :label="$t('rewardProgram.statementTab')">
          <reward-program-statement
            :history="rewardProgramHistory"
            :is-using-mock-history="useMockHistory"
          />
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import RewardProgramRules from "./RewardProgramRules";
import RewardProgramStatement from "./RewardProgramStatement";

export default {
  mixins: [common],

  components: {
    RewardProgramRules,
    RewardProgramStatement
  },

  data() {
    return {
      activeTab: 0,
      isLoadingHistory: false,
      useMockHistory: false
    };
  },

  computed: {
    ...mapGetters(["rewardProgramHistory"])
  },

  methods: {
    getRewardProgramHistory() {
      this.isLoadingHistory = true;
      this.$store
        .dispatch("getRewardProgramHistory", {
          useMock: this.useMockHistory
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoadingHistory = false;
        });
    },

    applyTabsStyle() {
      const tabs = document.getElementsByClassName("tabs")[0];

      if (!tabs || !tabs.children[0] || !tabs.children[0].children.length) {
        return;
      }

      tabs.children[0].style.backgroundColor = "hsl(0, 0%, 96%)";

      Array.from(tabs.children[0].children).forEach((tab, index) => {
        const link = tab.children[0];

        if (!link) {
          return;
        }

        if (index === this.activeTab) {
          link.style.setProperty("color", this.$primaryColor, "important");
          link.style.setProperty(
            "border-bottom-color",
            this.$primaryColor,
            "important"
          );
        } else {
          link.style.removeProperty("color");
          link.style.removeProperty("border-bottom-color");
        }
      });
    },

    handleTabChange() {
      this.$nextTick(() => {
        this.applyTabsStyle();
      });
    }
  },

  mounted() {
    this.getRewardProgramHistory();
    this.$nextTick(() => {
      this.applyTabsStyle();
    });
  }
};
</script>

<style scoped>
#reward-program-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}

.reward-program-header {
  margin-bottom: 1.5rem;
}

.reward-program-header .subtitle {
  margin-top: 0.35rem;
}
</style>
